/* global Foundation */

import $ from 'jquery'
import { destroyVideos, setupVideos } from './_video'

const $body = $(document.body)

function replaceLazyContent(modal) {
  const lazies = modal.querySelectorAll('.lazy-content')
  lazies.forEach((lazyEl) => {
    const { html } = lazyEl.dataset
    if (!html) return

    const fragment = document.createRange().createContextualFragment(html)
    lazyEl.replaceWith(fragment)
  })
}

function setupModal(modal) {
  const $modal = $(modal)
  if (!modal || !$modal.length) {
    return null
  }

  if ($modal.data('zfPlugin')) {
    return $modal.data('zfPlugin')
  }

  $modal
    .off('open.zf.reveal')
    .off('closed.zf.reveal')
    .on('open.zf.reveal', () => {
      replaceLazyContent($modal[0])
      setupVideos($modal[0], true, true)
      $body.addClass('blurred')
    })
    .on('closed.zf.reveal', () => {
      destroyVideos($modal)
      $body.removeClass('blurred')
    })

  return new Foundation.Reveal($modal, { vOffset: $modal.data('v-offset') ?? 60 })
}

function setupModals(container) {
  $(container)
    .find('a[href^="#modal-"]')
    .each((idx, anchor) => {
      const $anchor = $(anchor)
      const $modal = $($anchor.attr('href'))

      $anchor.on('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
      })

      const modal = setupModal($modal)
      if (modal) {
        $anchor.on('click', () => {
          modal.open()
        })
      }
    })
}

function destroyModals(container) {
  const promises = []

  $(container)
    .find('a[href^="#modal-"]')
    .each((idx, anchor) => {
      const $anchor = $(anchor)
      const $modal = $($anchor.attr('href'))

      if (!$modal.length) {
        return
      }

      promises.push(
        new Promise((resolve) => {
          if ($modal.data('zfPlugin')) {
            $modal.on('closed.zf.reveal', () => {
              $modal.foundation('destroy')
              $modal.remove()
              resolve()
            })
            $modal.trigger('closed.zf.reveal')
          } else {
            resolve()
          }
        }),
      )
    })

  return promises
}

export { setupModal, setupModals, destroyModals }
